import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const handleUpdateIndex = (swiper) => {
  const element = document.querySelector('.js-slider-index');

  if (element) {
    element.textContent = String(swiper.realIndex + 1).padStart(2, '0');
  }
};

const Slider = () => {
  const sliderWrapper = document.querySelector('.js-slider');

  if (!sliderWrapper) {
    return;
  }

  const slider = sliderWrapper.querySelector('.swiper');

  if (slider) {
    new Swiper(slider, {
      modules: [Navigation],
      lazy: true,
      spaceBetween: 0,
      slidesPerView: 1,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      on: {
        navigationPrev: handleUpdateIndex,
        navigationNext: handleUpdateIndex,
      },
    });
  }
};

export default Slider;
